import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled, { css } from 'styled-components';
export const modalContainerStyles = css `
  --bgColor: ${brand.global.white};
  --tintColor: rgba(0, 0, 0, 0.75);

  &[data-site='ess'] {
    --fgColor: ${brand.ess.primary};
  }

  &[data-site='mep'] {
    --fgColor: ${brand.mep.primary};
  }

  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  color: var(--fgColor);
  height: 100%;
  place-content: center;
  place-items: center;
  width: 100%;
  z-index: 999;

  &[data-open='false'] {
    display: none;
  }
`;
export const modalInnerStyles = css `
  position: relative;
  pointer-events: none;
  width: 100vw;
`;
export const modalContentContainerStyles = css `
  ${baseGrid};
  pointer-events: none;

  [data-site='ess'] & {
    --bgColour: ${brand.global.white};
    --borderColour: ${brand.global.red};
  }

  [data-site='mep'] & {
    --bgColour: ${brand.global.white};
    --borderColour: ${brand.global.red};
  }
`;
export const modalContentInnerStyles = css `
  ${scrollbars};
  position: relative;
  pointer-events: all;
  background-color: var(--bgColour);
  border-top: 3px solid var(--borderColour);
  padding: ${fluid(30, 64)} ${fluid(30, 150)};
  grid-column: 1 / span 6;
  margin: 0 18px;
  max-height: 80vh;
  overflow: auto;

  @media ${from(Device.Tablet)} {
    grid-column: 2 / span 6;
    margin: 0;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 4 / span 6;
  }
`;
const Container = styled(SectionWrapper) `
  ${modalContainerStyles};
`;
const Inner = styled.div `
  ${modalInnerStyles};
`;
export const ModalContentContainer = styled.div `
  ${modalContentContainerStyles};
`;
export const ModalContentInner = styled.div `
  ${modalContentInnerStyles};
`;
const ModalStyles = {
    Container,
    Inner,
};
export default ModalStyles;
